module.exports=function(scope){ return `<div class="asseco-mask">
    <div class="asseco-absolute-center asseco-group-mask-message">
        <span class="groupName">&#160;</span>

        <div class="asseco-group-mask-wait">
            <span class="waitOrder"></span>
            <span class="waitExpectancy"></span>
        </div>
        <div class="asseco-absolute-center asseco-group-mask-cancel">
            <a class="mdl-button mdl-button--colored">${scope.cancelText}</a>
        </div>
        ${scope.dm ? `
            <div class="asseco-absolute-center asseco-group-mask-dm">
                <a class="mdl-button mdl-button--colored mdl-button--raised">${scope.dmText}</a>
            </div>`
        : ''}
        <div class="asseco-group-mask-status"></div>
    </div>
</div>`};